/**
 * A/B Test: sticky header
 *
 * body attribute (IntelliGems / AB tool):
 *   data-elios-sticky-header-test="true"  → Test A / control — header is not sticky
 *   data-elios-sticky-header-test="false" → Test B / variant — header is sticky
 */
(function () {
  'use strict';

  if (window.__eliosStickyHeaderABTestInit) return;
  window.__eliosStickyHeaderABTestInit = true;

  var BODY_ATTR = 'data-elios-sticky-header-test';

  function getBodyAttr() {
    if (document.body && document.body.hasAttribute(BODY_ATTR)) {
      return document.body.getAttribute(BODY_ATTR);
    }

    if (document.documentElement && document.documentElement.hasAttribute(BODY_ATTR)) {
      return document.documentElement.getAttribute(BODY_ATTR);
    }

    return null;
  }

  function isVariantTest() {
    return String(getBodyAttr()).toLowerCase() === 'false';
  }

  function syncClasses() {
    var body = document.body;
    if (!body) return;

    var active = isVariantTest();
    body.classList.toggle('elios-sticky-header-test-a', !active);
    body.classList.toggle('elios-sticky-header-test-b', active);
  }

  function applySticky() {
    var active = isVariantTest();
    var root = document.documentElement;
    var headerSection = document.querySelector('.shopify-section--header');
    var storeHeader = document.querySelector('store-header');

    root.style.setProperty('--sticky-header-enabled', active ? '1' : '0');

    if (storeHeader) {
      if (active) {
        storeHeader.setAttribute('sticky', '');
      } else {
        storeHeader.removeAttribute('sticky');
      }
    }

    if (headerSection) {
      if (active) {
        headerSection.style.setProperty('position', 'sticky', 'important');
        headerSection.style.top = '0';
        headerSection.style.zIndex = '10';
      } else {
        headerSection.style.removeProperty('position');
        headerSection.style.removeProperty('top');
        headerSection.style.removeProperty('z-index');
      }
    }
  }

  function sync() {
    syncClasses();
    applySticky();
  }

  function init() {
    sync();

    var observer = new MutationObserver(sync);

    if (document.body) {
      observer.observe(document.body, {
        attributes: true,
        attributeFilter: [BODY_ATTR]
      });
    }

    if (document.documentElement) {
      observer.observe(document.documentElement, {
        attributes: true,
        attributeFilter: [BODY_ATTR]
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
